import React from "react";
import { Box, Typography } from "@mui/material";

import BalanceIcon from "@mui/icons-material/Balance";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import PieChartOutlineIcon from "@mui/icons-material/PieChartOutline";
import PieChartIcon from "@mui/icons-material/PieChart";

import { summaryCards } from "./constants";

const iconMap = {
  Balance: BalanceIcon,
  Inventory2Outlined: Inventory2OutlinedIcon,
  PieChartOutline: PieChartOutlineIcon,
  PieChart: PieChartIcon,
};

const CapacitySummary = ({ summary }) => {
  return (
    <Box
      sx={{
        display: "flex",    
        gap: 1,
        mb: 0,
      }}
    >
      {summaryCards.map((card) => {
        const Icon = iconMap[card.icon];

        return (
          <Box
            key={card.key}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.5,
              minHeight: 80,
              p:0,
              paddingRight:1,
              borderRadius: "6px",
              backgroundColor: card.bg,
            }}
          >
            <Box
              sx={{
                width: 46,
                height: 46,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "6px",
                backgroundColor: "rgba(255,255,255,.6)",
                color: card.color,
              }}
            >
              <Icon sx={{ fontSize: 28 }} />
            </Box>

            <Box>
              <Typography
                sx={{
                  fontSize: 12,
                  fontWeight: 700,
                  color: card.color,
                }}
              >
                {card.title}
              </Typography>

              <Typography
                sx={{
                  fontSize: 24,
                  fontWeight: 800,
                  color: "#111827",
                }}
              >
                {summary?.[card.key] ?? 0}

                {card.unit && (
                  <Box
                    component="span"
                    sx={{
                      ml: 0.5,
                      fontSize: 12,
                      fontWeight: 700,
                    }}
                  >
                    {card.unit}
                  </Box>
                )}
              </Typography>
            </Box>
          </Box>
        );
      })}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.5,
          minHeight: 80,
          p: 0,
          paddingRight:1,
          borderRadius: "6px",
          backgroundColor:'#fff3ea',
        }}
      >
        <Box
          sx={{
            width: 46,
            height: 46,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "6px",
            backgroundColor: "rgba(255,255,255,.6)",
            color: '#f05a00',
          }}
        >
          <PieChartIcon sx={{ fontSize: 28 }} />
        </Box>

        <Box>
          <Typography
            sx={{
              fontSize: 14,
              fontWeight: 700,
              color:'#f05a00',
            }}
          >
           {`LR count: ${summary?.LRCount ?? 0}`}
          </Typography>
          <Typography
            sx={{
              fontSize: 14,
              fontWeight: 700,
              color: '#f05a00',
            }}
          >
            {`LR amount: ${summary?.LRAmount ?? 0}`}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default CapacitySummary;
